<template>
  <div>
    <v-radio-group
      v-model="selectedOption"
      class="mt-0 radio-group"
      hide-details
      @change="changeHandler"
    >
      <template v-slot:label>
        <div class="header">
          <div class="header__title">{{ title }}</div>
          <div class="header__subtitle">
            {{ subtitle }}
          </div>
        </div>
      </template>
      <v-radio
        v-for="option in localOptions"
        :key="option.id"
        :value="option"
        class="radio"
        :ripple="false"
      >
        <template v-slot:label>
          <div class="radio__label">
            <span>{{ option.name }}</span>
            <template v-if="option.date && !option.custom">
              - {{ option.date }}
            </template>
          </div>
        </template>
      </v-radio>
    </v-radio-group>
    <div v-if="selectedOption.custom" class="input-row">
      <v-menu
        ref="dateMenu"
        v-model="dateMenu"
        :close-on-content-click="false"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            :label="$t('message.common.date')"
            prepend-icon="icon-calendar"
            readonly
            hide-details
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="date" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false">
            {{ $t("message.common.cancel") }}
          </v-btn>
          <v-btn text color="primary" @click="saveDate(date)">
            {{ $t("message.common.ok") }}
          </v-btn>
        </v-date-picker>
      </v-menu>

      <v-menu
        ref="timeMenu"
        v-model="timeMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="time"
            :label="$t('message.common.hour')"
            prepend-icon="icon-status-pending"
            readonly
            hide-details
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="timeMenu"
          hide-details
          v-model="time"
          format="24hr"
          full-width
          :allowed-minutes="[0, 30]"
          @click:minute="saveTime(time)"
        ></v-time-picker>
      </v-menu>
    </div>
    <PostFacilitiesAlert
      v-if="selectedOption.id !== localOptions[0].id && type"
      :type="type"
      class="mt-6"
    />
  </div>
</template>

<script>
import moment from "moment";
import { FORMAT } from "@/config/date-format";

export default {
  name: "PublicationDatePicker",
  components: {
    PostFacilitiesAlert: () => import("@/components/Posts/PostFacilitiesAlert")
  },
  props: {
    title: {
      required: true,
      type: String
    },
    subtitle: {
      required: true,
      type: String
    },
    options: {
      required: true,
      type: Array
    },
    editMode: {
      type: Boolean,
      default: false
    },
    publishAt: {
      type: String
    },
    type: {
      type: String
    },
    alertAvailable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localOptions: null,
      selectedOption: null,
      date: new Date(Date.now()).toISOString().substr(0, 10),
      time: "09:00",
      dateMenu: false,
      timeMenu: false
    };
  },
  computed: {
    customDate() {
      return moment(new Date(`${this.date} ${this.time}`));
    }
  },
  created() {
    if (this.editMode && this.publishAt) {
      this.date = moment(this.publishAt).format(FORMAT.DATE);
      this.time = moment(this.publishAt).format(FORMAT.TIME);
    }
    this.localOptions = this.options;
    const customOption = this.localOptions.find(item => item.custom);
    customOption.date = this.customDate.format(FORMAT.MMDDYYYY);
    customOption.value = this.customDate.format();
    this.selectedOption = this.editMode ? this.options.at(-1) : this.options[0];
    this.changeHandler(this.selectedOption);
  },
  methods: {
    changeHandler({ value, type }) {
      this.$emit("change", { value: value || null, type });
    },
    emitCustomOption() {
      const customOption = this.localOptions.find(item => item.custom);
      customOption.date = this.customDate.format(FORMAT.MMDDYYYY);
      customOption.value = this.customDate.format();
      this.changeHandler(customOption);
    },
    saveDate(date) {
      this.emitCustomOption();
      this.$refs.dateMenu.save(date);
    },
    saveTime(time) {
      this.emitCustomOption();
      this.$refs.timeMenu.save(time);
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  color: $dark-blue-3;
  &__title {
    font-weight: 600;
    margin-bottom: $spacing;
  }
}

.radio {
  margin-top: $spacing * 2;
  margin-bottom: 0 !important;

  &__label {
    color: $dark-blue-3;
    @include font-size(14px);

    span {
      font-weight: 600;
    }
  }
}

.input-row {
  display: flex;
  max-width: 290px;
  margin-top: $spacing;

  & > * + * {
    margin-left: $spacing * 2;
  }
}

.radio-group {
  ::v-deep .v-input__slot {
    margin: 0;
  }
}
</style>
